import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { alpha, Box, BoxProps, styled } from '@mui/material';

import { buildImageSrc } from '@utils/imageUtils';

type BackgroundImageProps = BoxProps<'img'>;

const StyledImage = styled(Box)`
  height: 100%;
  width: 100%;
  mask-image: ${({ theme }) =>
    `linear-gradient(to bottom, ${alpha(theme.palette.background.default, 0.7)} 0%, ${alpha(
      theme.palette.background.default,
      0.2
    )} 60%, transparent 80%)`};
` as typeof Box;

export const BackgroundImage: FC<BackgroundImageProps> = ({ src, alt, ...rest }) => {
  const { t } = useTranslation();
  const [hash] = useState(() => Date.now());

  return src ? (
    <Box flex={1} height='auto' overflow='hidden' position='absolute' width={1}>
      <StyledImage
        alt={alt ?? t('backgroundImage')}
        component='img'
        src={buildImageSrc(src, hash)}
        {...rest}
      />
    </Box>
  ) : null;
};

BackgroundImage.displayName = 'BackgroundImage';
